export const strings = {
    "message.welcome": "Bienvenido"
}